import type { ReadinessGateDefinition, ReadinessGateId, ReadinessGateStatus } from '@/types/readiness-gates';

/** Gate definitions per docs/operations/01-customer-operations.md */
export const READINESS_GATE_DEFINITIONS: readonly ReadinessGateDefinition[] = [
  {
    gateId: 'G1',
    label: 'Signed contract + MAP',
    blocksLabel: 'Production',
    defaultOwner: 'Customer / Sales',
    blocksInstall: true,
  },
  {
    gateId: 'G2',
    label: 'POS credentials tested',
    blocksLabel: 'Data sync',
    defaultOwner: 'Customer IT + TPB',
    blocksInstall: true,
  },
  {
    gateId: 'G3',
    label: 'Catalog live in POS (min threshold)',
    blocksLabel: 'Onboarding',
    defaultOwner: 'Customer',
    blocksInstall: true,
  },
  {
    gateId: 'G4',
    label: 'Network spec',
    blocksLabel: 'Install schedule',
    defaultOwner: 'Customer',
    blocksInstall: true,
  },
  {
    gateId: 'G5',
    label: 'Customer hardware on site',
    blocksLabel: 'Install',
    defaultOwner: 'Customer',
    blocksInstall: true,
  },
  {
    gateId: 'G6',
    label: 'Power / placement spec',
    blocksLabel: 'Install',
    defaultOwner: 'Customer',
    blocksInstall: true,
  },
  {
    gateId: 'G7',
    label: 'Named retail lead + training roster',
    blocksLabel: 'Training',
    defaultOwner: 'Customer',
    blocksInstall: false,
  },
  {
    gateId: 'G8',
    label: 'Brand/spotlight content or approved default',
    blocksLabel: 'Go-live',
    defaultOwner: 'Customer',
    blocksInstall: false,
  },
  {
    gateId: 'G9',
    label: 'Staff briefing',
    blocksLabel: 'Go-live',
    defaultOwner: 'Customer',
    blocksInstall: false,
  },
  {
    gateId: 'G10',
    label: 'Go-live QA signoff',
    blocksLabel: 'Stabilization clock',
    defaultOwner: 'Joint',
    blocksInstall: false,
  },
] as const;

export const READINESS_GATE_IDS = READINESS_GATE_DEFINITIONS.map((gate) => gate.gateId);

export const READINESS_GATE_STATUS_LABELS: Record<ReadinessGateStatus, string> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  complete: 'Complete',
  blocked: 'Blocked',
  waived: 'Waived',
};

export const INSTALL_BLOCK_GATE_IDS: ReadinessGateId[] = READINESS_GATE_DEFINITIONS.filter(
  (gate) => gate.blocksInstall
).map((gate) => gate.gateId);

export function getReadinessGateDefinition(gateId: ReadinessGateId): ReadinessGateDefinition {
  const definition = READINESS_GATE_DEFINITIONS.find((gate) => gate.gateId === gateId);
  if (!definition) {
    throw new Error(`Unknown readiness gate: ${gateId}`);
  }
  return definition;
}
